module.exports = __webpack_public_path__ + "static/media/g-9.e7c2994d.jpg";